module.exports = __webpack_public_path__ + "static/media/contact.3882ed41.png";


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/assets/images/contact.png
// module id = 3436
// module chunks = 895